import { render, staticRenderFns } from "./monitors-requests.vue?vue&type=template&id=46288e44&"
import script from "./monitors-requests.vue?vue&type=script&lang=js&"
export * from "./monitors-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports